export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14605.e86db296.jpg";